import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DocumentTypeRoutingModule } from './document-type-routing.module';
import { DocumentTypeIndexComponent } from './document-type-index/document-type-index.component';
import { DocumentTypesTableComponent } from './components/document-types-table/document-types-table.component';
import { CreateOrUpdateDocumentTypeModalComponent } from './components/create-or-update-document-type-modal/create-or-update-document-type-modal.component';

const MATERIAL_MODULES = [
  MatButtonModule,
  MatTableModule,
  MatInputModule,
  MatChipsModule,
  MatCardModule,
  MatIconModule,
  MatDialogModule,
  MatSelectModule,
  MatMenuModule,
  MatPaginatorModule,
  MatCheckboxModule,
  MatProgressSpinnerModule
];

@NgModule({
  declarations: [
    DocumentTypeIndexComponent,
    DocumentTypesTableComponent,
    CreateOrUpdateDocumentTypeModalComponent
  ],
  imports: [
    CommonModule,
    CdkMenuModule,
    ReactiveFormsModule,
    DocumentTypeRoutingModule,
    MATERIAL_MODULES
  ]
})
export class DocumentTypeModule { }
